var map = {
	"./Montserrat": [
		"1451"
	],
	"./Montserrat/": [
		"1451"
	],
	"./Montserrat/Montserrat-Bold-normal": [
		"335a"
	],
	"./Montserrat/Montserrat-Bold-normal.js": [
		"335a"
	],
	"./Montserrat/Montserrat-ExtraBold-normal": [
		"f900"
	],
	"./Montserrat/Montserrat-ExtraBold-normal.js": [
		"f900"
	],
	"./Montserrat/Montserrat-Medium-normal": [
		"ba72"
	],
	"./Montserrat/Montserrat-Medium-normal.js": [
		"ba72"
	],
	"./Montserrat/Montserrat-Regular-normal": [
		"3b5f"
	],
	"./Montserrat/Montserrat-Regular-normal.js": [
		"3b5f"
	],
	"./Montserrat/Montserrat-SemiBold-normal": [
		"a093"
	],
	"./Montserrat/Montserrat-SemiBold-normal.js": [
		"a093"
	],
	"./Montserrat/index": [
		"1451"
	],
	"./Montserrat/index.ts": [
		"1451"
	],
	"./Poppins": [
		"b7a9"
	],
	"./Poppins/": [
		"b7a9"
	],
	"./Poppins/Poppins-Bold": [
		"f634"
	],
	"./Poppins/Poppins-Bold.js": [
		"f634"
	],
	"./Poppins/Poppins-Medium": [
		"6752"
	],
	"./Poppins/Poppins-Medium.js": [
		"6752"
	],
	"./Poppins/Poppins-Regular": [
		"52cc"
	],
	"./Poppins/Poppins-Regular.js": [
		"52cc"
	],
	"./Poppins/Poppins-SemiBold": [
		"5d8c"
	],
	"./Poppins/Poppins-SemiBold.js": [
		"5d8c"
	],
	"./Poppins/index": [
		"b7a9"
	],
	"./Poppins/index.ts": [
		"b7a9"
	],
	"./arabic": [
		"aad9",
		"chunk-2d21316b"
	],
	"./arabic.ts": [
		"aad9",
		"chunk-2d21316b"
	],
	"./bengali": [
		"fcb3",
		"chunk-2d237e84"
	],
	"./bengali.ts": [
		"fcb3",
		"chunk-2d237e84"
	],
	"./cambodian": [
		"28f3",
		"chunk-2d0b3a49"
	],
	"./cambodian.ts": [
		"28f3",
		"chunk-2d0b3a49"
	],
	"./chinese": [
		"462c"
	],
	"./chinese.ts": [
		"462c"
	],
	"./gujarati": [
		"f395",
		"chunk-2d22c55f"
	],
	"./gujarati.ts": [
		"f395",
		"chunk-2d22c55f"
	],
	"./japanese": [
		"e7c7"
	],
	"./japanese.ts": [
		"e7c7"
	],
	"./korean": [
		"5e86"
	],
	"./korean.ts": [
		"5e86"
	],
	"./module": [
		"b592"
	],
	"./module/": [
		"b592"
	],
	"./module/index": [
		"b592"
	],
	"./module/index.ts": [
		"b592"
	],
	"./nepali": [
		"7a22",
		"chunk-2d0e13c0"
	],
	"./nepali.ts": [
		"7a22",
		"chunk-2d0e13c0"
	],
	"./notosans": [
		"b2e6",
		"chunk-2d20f577"
	],
	"./notosans.ts": [
		"b2e6",
		"chunk-2d20f577"
	],
	"./punjabi": [
		"9d66",
		"chunk-2d0f0841"
	],
	"./punjabi.ts": [
		"9d66",
		"chunk-2d0f0841"
	],
	"./sinhala": [
		"823b",
		"chunk-2d0dd7ff"
	],
	"./sinhala.ts": [
		"823b",
		"chunk-2d0dd7ff"
	],
	"./tamil": [
		"c328",
		"chunk-2d21676c"
	],
	"./tamil.ts": [
		"c328",
		"chunk-2d21676c"
	],
	"./telugu": [
		"ad04",
		"chunk-2d21365d"
	],
	"./telugu.ts": [
		"ad04",
		"chunk-2d21365d"
	],
	"./thai": [
		"e9d5",
		"chunk-2d226cbb"
	],
	"./thai.ts": [
		"e9d5",
		"chunk-2d226cbb"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "cfbd6";
module.exports = webpackAsyncContext;